import React from 'react';
import strings from 'strings';
import FPHint from 'UI/components/atoms/FPHint';
import FPHtmlViewer from 'UI/components/atoms/FPHtmlViewer';

import { formatLastUpdateDate, formatLastUpdateTime } from '../UserToolReports.utils';

import { useStyles } from './styles';

export const Header = ({ lastUpdates }) => {
  const classes = useStyles();

  return (
    <FPHint
      description={
        <>
          {strings.dashboard.toolsUsage.updateInfo.title}
          <ul>
            <li>
              <FPHtmlViewer
                content={strings.formatString(
                  strings.dashboard.toolsUsage.updateInfo.thirtyMinutesUpdate,
                  {
                    updatedFields: 'Bulks, Calls and Draw Balance',
                    date: formatLastUpdateDate(lastUpdates.bulks),
                    time: formatLastUpdateTime(lastUpdates.bulks)
                  }
                )}
              />
            </li>
            <li>
              <FPHtmlViewer
                content={strings.formatString(strings.dashboard.toolsUsage.updateInfo.inMails, {
                  date: formatLastUpdateDate(lastUpdates.inmails),
                  time: formatLastUpdateTime(lastUpdates.inmails)
                })}
              />
            </li>
            <li>
              <FPHtmlViewer
                content={strings.formatString(strings.dashboard.toolsUsage.updateInfo.livePosts, {
                  date: formatLastUpdateDate(lastUpdates.live_posts),
                  time: formatLastUpdateTime(lastUpdates.live_posts)
                })}
              />
            </li>
          </ul>
        </>
      }
      size="md"
      containerClassName={classes.boxCopyWrapper}
      typographyProps={{ component: 'div' }}
    />
  );
};
